import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import SubPaywall from '../../../DeviationViews/Full/_partials/SubPaywall';
import StatBlock from '../../Details/_partials/StatBlock';
import TextContent from '../../Details/_partials/TextContent';
import s from './Journal.scss';
const JournalContent = ({ deviation: { textContent  } , deviation , withArtist =true  })=>{
    var _deviation_extended, _deviation_extended1;
    const isLegacy = (textContent === null || textContent === void 0 ? void 0 : textContent.html.type) === 'writer';
    const isLegacyView = isLegacy && !((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.journalSkinFullwidth);
    const isFullWidthView = isLegacy && ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.journalSkinFullwidth);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const isMobile = useContext(MobileContext);
    const { isSubscribedButBlocked , needsSubscription  } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    // only show here in full screen, otherwise it's shown in DesktopLayout in the left column
    const { isFullscreen  } = useDeviationViewContext();
    const shouldShowFullscreenSubPaywall = isBlocked && isFullscreen;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, withArtist && /*#__PURE__*/ React.createElement("div", {
        className: s['author-block']
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation
    }), !isMobile && ' '), /*#__PURE__*/ React.createElement(StatBlock, {
        className: s['stats'],
        deviation: deviation
    }), !isBlocked && /*#__PURE__*/ React.createElement("div", {
        className: s['wrapper']
    }, isExtendedLoaded && /*#__PURE__*/ React.createElement(TextContent, {
        className: classnames(s['text-content'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin']),
        textContent: textContent,
        deviationId: deviation.deviationId,
        disableStylesForLegacy: isFullWidthView
    })), shouldShowFullscreenSubPaywall && /*#__PURE__*/ React.createElement(SubPaywall, {
        className: s['paywall'],
        deviation: deviation,
        showImage: false
    }));
};
JournalContent.displayName = 'JournalContent';
export default JournalContent;
